import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import defaultTo from 'ramda/es/defaultTo';
import head from 'ramda/es/head';
import Input from '@client/components/formComponents/input/Input';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import FormWrapper from '@client/components/formComponents/formWrapper/FormWrapper';
import LabelWrapper from '@client/components/formComponents/labelWrapper/LabelWrapper';
import Textarea from '@client/components/formComponents/textarea/Textarea';
import {
  valueOrEmptyStr,
  remapObjValueToString,
} from '@client/shared/utils/utils/utils';
import { shareByEmail } from '@client/redux/fundraiser/fundraiserActions';
import RecaptchaConditions from '@client/components/recaptchaConditions/RecaptchaConditions';
import styles from './emailShareForm.scss';

class EmailShareForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      status: 'incomplete',
      genericError: null,
    };
  }

  submitEmailShare = (values, { setErrors }) => {
    const { dispatch, fundraiserId } = this.props;
    const { status } = this.state;

    if (status === 'submitting') {
      return;
    }

    this.setState(
      {
        status: 'submitting',
      },
      () => {
        dispatch(shareByEmail(fundraiserId, values))
          .then(() => {
            this.setState({
              status: 'submitted',
              genericError: null,
            });
          })
          .catch((error) => {
            if (error) {
              const { detail, errors } = error;
              if (errors) {
                this.setState({
                  status: 'incomplete',
                  genericError: head(
                    defaultTo([], errors.googleReCaptchaToken)
                  ),
                });
                setErrors(remapObjValueToString(errors));
              } else if (detail) {
                // If the server gives us a generic error message, it uses 'detail'
                this.setState({
                  status: 'incomplete',
                  genericError: detail,
                });
              }
            } else {
              // If anything else goes wrong, we give a default error.
              this.setState({
                status: 'incomplete',
                genericError:
                  'Ett fel har inträffat, kunde inte skicka e-postmeddelandet',
              });
            }
          });
      }
    );
  };

  renderForm = (formProps) => {
    const { toggleModal } = this.props;
    const { genericError } = this.state;
    const { errors, values, handleChange, handleBlur } = formProps;

    return (
      <form onSubmit={formProps.handleSubmit} className={styles.emailShareForm}>
        <div className={styles.fields}>
          <h3>BJUD IN EN VÄN TILL INSAMLINGEN VIA E-POST</h3>
          <p>{'Ange e-postadress till den du vill bjuda in nedan'}</p>
          {genericError && <p className={styles.error}>{genericError}</p>}
          <LabelWrapper
            labelText={'DITT NAMN *'}
            errorLabel={errors.senderName}
          >
            <Input
              name={'senderName'}
              value={valueOrEmptyStr(values.senderName)}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </LabelWrapper>
          <LabelWrapper
            labelText={'MOTTAGARENS E-POST *'}
            errorLabel={errors.recipient}
          >
            <Input
              name={'recipient'}
              value={valueOrEmptyStr(values.recipient)}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </LabelWrapper>
          <LabelWrapper labelText={'MEDDELANDE'} errorLabel={errors.message}>
            <Textarea
              className={styles.message}
              name={'message'}
              value={valueOrEmptyStr(values.message)}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </LabelWrapper>
          <RecaptchaConditions />
        </div>
        <div className={styles.actions}>
          <button type="submit" className={`${styleHelper.btnPrimaryLg}`}>
            Skicka
          </button>
          <a onClick={toggleModal} className={styleHelper.linkPrimary}>
            Avbryt
          </a>
        </div>
      </form>
    );
  };

  render() {
    const { toggleModal } = this.props;
    const { status } = this.state;

    return status === 'submitted' ? (
      <div className={styles.emailShareForm}>
        <div className={styles.fields}>
          <h3>DIN INBJUDAN HAR SKICKATS</h3>
          <p>{'Tack, vi har skickat ett e-postmeddelande med din inbjudan.'}</p>
        </div>
        <div className={styles.actions}>
          <button
            onClick={toggleModal}
            type="submit"
            className={`${styleHelper.btnPrimaryLg}`}
          >
            Stäng
          </button>
        </div>
      </div>
    ) : (
      <FormWrapper
        onSubmit={this.submitEmailShare}
        component={this.renderForm}
        validateOnBlur={true}
        validateOnChange={false}
      />
    );
  }
}

EmailShareForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fundraiserId: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  toggleModal: PropTypes.func,
};

export default connect()(EmailShareForm);
